const channel = new BroadcastChannel("download-coordinator");

const tabId = sessionStorage.getItem("tabId") || (() => {
  const id = `${Date.now()}-${Math.random()}`;
  sessionStorage.setItem("tabId", id);
  return id;
})();

let downloadHandled = {};

export const shouldHandleDownload = (eventId) => {
  return new Promise(resolve => {
    if (downloadHandled[eventId]) return resolve(false); // prevent double run

    // Listen for broadcast saying "another tab is downloading"
    const timeout = setTimeout(() => {
      // No one claimed responsibility within time → this tab handles
      downloadHandled[eventId] = true;
      channel.postMessage({ eventId, by: tabId });
      resolve(true);
    }, 50); // small delay to allow race coordination

    const listener = msg => {
      if (msg.data?.eventId === eventId && msg.data?.by !== tabId) {
        clearTimeout(timeout);
        channel.removeEventListener("message", listener);
        resolve(false); // another tab already claimed it
      }
    };

    channel.addEventListener("message", listener);
  });
}
